module.exports = __webpack_public_path__ + "static/img/21-0623-detail1.c26bf70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/21-0623-detail1.jpg
// module id = GenL
// module chunks = 0